import appReducer from "./appReducer";

const appReducers = {
    app: appReducer
}

export default appReducers